
export default function(o, result, itemWidth, itemHeight){

  var titleSlug = result.titleSlug

  var click = function(){
    history.pushState({}, '', `/stories/${titleSlug}`)
    o.store(`storiesGridItemClicked_${result.titleSlug}`,true)
    o.render(o)
  }

  var imageDiv = $('<img>')

  var resize = function(w, h){
    itemWidth = w
    itemHeight = h
    imageDiv.attr({
      width: itemWidth,
      height: itemHeight,
    })
    div.css({
      width: `${itemWidth}px`,
      height: `${itemHeight}px`,
    })
  }

  var isActive = false

  var isVisited = o.store(`storiesGridItemClicked_${result.titleSlug}`)

  var start = function(){

    if(isActive){ return }
    isActive = true

    var labelDiv = o.component.gridItemLabel(o, result.label, result.sublabel, true)

    if(isVisited){
      labelDiv.addClass('visited')
    }
  
    imageDiv.attr({
      src: result.imageUrl,
      width: itemWidth,
      height: itemHeight,
      zIndex: 0,
    })
    .css({
      borderRight: '5px solid black',
      borderBottom: '5px solid black',
      position: 'absolute',
      top: 0,
      left: 0,
    })

    div
    .css({
      cursor: 'pointer',
    })
    .append([
      imageDiv,
      labelDiv,
    ])
    .hover(
      function(){
        // o.util.soundTick(o)
        labelDiv.css({color: o.colors.red})
      },
      function(){
        labelDiv.css({color: ''})
      }
    )

  }

  var stop = function(){

    if(!isActive){ return }
    isActive = false

    div
    .empty()
    .unbind('mouseenter')
    .unbind('mouseleave')

  }

  var div =
    $('<div>')
    .css({
      borderRight: '5px solid black',
      borderBottom: '5px solid black',
      display: 'inline-flex',
      position: 'relative',
      backgroundColor: 'rgba(255,255,255,0.1)',
      width: `${itemWidth}px`,
      height: `${itemHeight}px`,
      alignItems: 'center',
      justifyContent: 'center',
      verticalAlign: 'top',
      lineHeight: '1.2em',
      cursor: 'pointer',
    })
    .click(click)

  div.start = start
  div.stop = stop
  div.resize = resize

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/stories/grid/item/item.js